import React from "react";
import phone from "../Signup/image/phone.png";
import line from "../Signup/image/line.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = ({ data1, setData1, operation, setOpeartion1 }) => {
  const navigate = useNavigate();

  const Handler = (e) => {
    const { name, value } = e.target;
    setData1((val) => ({ ...val, [name]: value }));
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    const match = operation.filter(
      (x) => x.email === data1.Email && x.password === data1.Password
    );
    if (match.length > 0) {
      setOpeartion1((val) => [...val, match[0]]);
      toast.success("Successfully Login", {
        position: "top-center",
        onClose: () => {
          navigate("/");
        },
        theme: "dark",
      });
    } else {
      toast.error("Unsuccessful", {
        position: "top-center",
        theme: "dark",
      });
    }
    setData1({
      Email: "",
      Password: "",
    });
  };

  return (
    <div className="container my-16 sm:my-20 lg:my-24 2xl:mx-auto">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-20 px-[5%]">
        {/* === Left Image Section === */}
        <div className="left-signup w-full lg:w-1/2 flex justify-center lg:justify-start">
          <img
            src={phone}
            className="w-[90%] sm:w-[75%] lg:w-auto h-auto object-contain"
            alt="side"
          />
        </div>

        {/* === Right Form Section === */}
        <div className="right-signup w-full lg:w-1/2 max-w-[480px]">
          <form onSubmit={HandleSubmit}>
            <h1 className="text-2xl sm:text-3xl lg:text-[36px] font-sans font-medium">
              Log in to Exclusive
            </h1>
            <p className="text-[14px] sm:text-[16px] pt-2 font-medium">
              Enter your details below
            </p>

            {/* === Input Fields === */}
            <div className="flex flex-col gap-4 py-6">
              <div className="relative">
                <input
                  name="Email"
                  onChange={Handler}
                  value={data1.Email}
                  required
                  type="text"
                  className="outline-none w-full p-2 border-b border-gray-300 text-[14px] sm:text-[16px] bg-transparent"
                  placeholder="Email or Phone Number"
                />
                <img
                  src={line}
                  className="absolute left-0 bottom-0 w-full h-[2px] opacity-0"
                  alt="line"
                />
              </div>
              <div className="relative">
                <input
                  name="Password"
                  onChange={Handler}
                  value={data1.Password}
                  required
                  type="password"
                  className="outline-none w-full p-2 border-b border-gray-300 text-[14px] sm:text-[16px] bg-transparent"
                  placeholder="Password"
                />
                <img
                  src={line}
                  className="absolute left-0 bottom-0 w-full h-[2px] opacity-0"
                  alt="line"
                />
              </div>
            </div>

            {/* === Buttons === */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-4 sm:pt-6">
              <div className="bg-[#db4444] text-center py-3 sm:py-4 px-12 rounded font-sans font-medium w-full sm:w-auto">
                <button
                  type="submit"
                  className="text-white text-[15px] sm:text-[16px]"
                >
                  Log In
                </button>
              </div>
              <button className="text-[#db4444] text-[14px] sm:text-[16px]">
                Forget Password?
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
